import {
	TRIGGER_VALIDATE_MOBILE_API_CALL,
	TRIGGER_VALIDATE_MOBILE_API_CALL_SUCCESS,
	TRIGGER_CLEAR_MERCHANT_INFO_DETAILS,
} from 'redux/actionTypes';

export function triggerValidateMobileApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_VALIDATE_MOBILE_API_CALL,
		data,
		stopLoader,
		callback,
	};
}

export function triggerValidateMobileApiCallSuccess(data) {
	return {
		type: TRIGGER_VALIDATE_MOBILE_API_CALL_SUCCESS,
		data,
	};
}
